import React from 'react';
import { Wrapper, Container } from './style';
import { Toast } from 'antd-mobile';
import { get } from '../../utils/request';
import CountUp from "react-countup";
import Config from '../../config';
import portrait from '../../assets/images/portrait.png';
import icon_sj from '../../assets/images/icon_sj.png';
import icon_right from '../../assets/images/icon_right.png';
import icon_ques from '../../assets/images/icon_ques.png';

class List extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      isShowTip: false,
      obj: {},
      userInfo: {},
      bankInfo: {}
    }
  }
  async componentDidMount() {
    document.title = '主页'
    this.loadInfo()
    this.loadList()
  }
  async loadInfo(){
    let params = {}
    let res = await get(`/pgy/user/${Config.appId}/home`, params)
    res = res.data.data
    this.setState({obj: res,userInfo: res.userInfo,bankInfo: res.bankInfo})
  }
  async loadList(){
    let params = {page: 1,pageSize: 1000,parent: ''}
    Toast.loading('', 10)
    let res = await get(`/pgy/user/${Config.appId}/invitationList`, params)
    Toast.hide()
    this.setState({list: res.data.data.records})
  }
  canTip(){
    this.setState({isShowTip: !this.state.isShowTip})
  }
  goDetail(){
    this.props.history.push(`/detail`)
  }
  goCard(){
    let value = this.state.bankInfo.paymentType
    if(value){
      this.props.history.push(`/account3`)
    } else{
      this.props.history.push(`/account2`)
    }
  }
  render() {
    let { list,isShowTip,obj,userInfo,bankInfo } = this.state;
    return (
      <Wrapper>
        <Container>
          <div className="topFixed">
            <div className="bg">
              <img className="left" src={userInfo.wxhead} />
              <div className="center">
                <p>{userInfo.realname}</p>
                <div>
                  <b>等级：{userInfo.gname}</b>
                  <div>
                    <img src={icon_ques} onClick={() => this.canTip()} />
                    {isShowTip&&(
                      <div>
                        <p>你的等级为{userInfo.gname}，每成功邀请1人，<br/> 最高可获得<span>{userInfo.promoteAmount}</span>元</p>
                      </div>
                    )}
                  </div>             
                </div>
              </div>
              <div className="right" onClick={() => this.goCard()}>
                <p>提现账户</p>
                {bankInfo.paymentType==1&&(<span>银行卡&nbsp;&nbsp;&nbsp;{bankInfo.accountNo}</span>)}
                {bankInfo.paymentType==2&&(<span>支付宝</span>)}
                {!bankInfo.paymentType&&(<span>未绑定</span>)}
              </div>
            </div>
            <div className="navs">
              <div className="top">      
                <div className="item">
                  <CountUp start={0} end={obj.balance} duration="1" decimals="2" className="red" />
                  <b>账户余额(元)</b>
                </div>
                <div className="item">
                  <CountUp start={0} end={obj.withdrawal} decimals="2" duration="1" />
                  <b>已提现(元)</b>
                </div>       
              </div>
              <div className="bottom">
                <div>
                  <p>累计收益</p>
                  <CountUp start={0} end={obj.totalIncome} decimals="2" duration="1" />
                </div>
                <p onClick={() => this.goDetail()}>
                  <span>查看明细</span>
                  <img src={icon_right} />      
                </p>
              </div>
            </div>
            <div className="title">
              <p>邀请记录</p>
              <span>邀请{obj.inviteNum}人，签约{obj.dealNum}人</span>
            </div>
            <div className="tables">
              <div className="table">
                <p>受邀人</p>
                <p><span>状态</span></p>
                <p><span>收益</span></p>
                <p>发展下线</p>
              </div>
            </div>
          </div>
          <div className="lists">
            <div className="list">
              {list.map((v, i) => (
                <div className="item" key={`key-list-${i}`}>
                  <div className="item1">
                    <p className="p1">{v.customerName}</p>
                    {v.commissionStatus==1&&(<p className="p2">沟通中</p>)}
                    {v.commissionStatus==2&&(<p className="p2">意向签约中</p>)}
                    {v.commissionStatus==3&&(<p className="p2 blue">签约成功</p>)}
                    {v.commissionStatus==4&&(<p className="p2">无意向</p>)}
                    <p className="p3">¥{v.commissionMoney}</p>
                    <p className="p4"><span>{v.inviteNum}</span></p>  
                  </div>
                  {v.subInvitationList != 0&&(
                    <div className="bgn">
                      <img src={icon_sj} />
                      {v.subInvitationList.map((v1, i1) => (
                        <div className="item2" key={`key-list-child-${i1}`}>
                          <p className="p1"><span>{v1.customerName}</span></p>
                          {v1.commissionStatus==1&&(<p className="p2">沟通中</p>)}
                          {v1.commissionStatus==2&&(<p className="p2">意向签约中</p>)}
                          {v1.commissionStatus==3&&(<p className="p2 blue">签约成功</p>)}
                          {v1.commissionStatus==4&&(<p className="p2">无意向</p>)}
                          <p className="p3">¥{v1.commissionMoney || 0}</p>
                          <p className="p4"><span>辅助成长金</span></p>  
                        </div>                
                      ))}
                    </div>         
                  )}
                </div>   
              ))}
              <div className="tips">
                {list.length==0&&(<p>暂无数据</p>)}
                {list.length!=0&&(<p>加载完成</p>)}
              </div>
            </div>
          </div>
        </Container>
      </Wrapper>
    );
  }
}
export default List;